import {INIT} from 'constants';
export { push } from 'react-router-redux';
export * from './socket';
export * from './connect';
export * from './error';
export * from './map';
export * from './map_search';
export * from './client';
export * from './clients';
export * from './user';
export * from './account';
export * from './tasks';
export * from './live_weather_center';
export * from './roleManagement';
export * from './features';
export * from './fields';
export * from './pipeline';
export * from './plans';
export * from './subscriptions';
export * from './jobs';
export * from './client_incidents';
export * from './contacts';
export * from './ui';
export * from './markers';
export * from './posts';
export * from './notifications';
export * from './integrations';
export * from './map-creator';
export * from './sales-site-manager';

export const init = f => ({
  type : INIT
});

export const hasPermission = path => ((dispatch, getState) => {
  const user = getState().connection.user;
  if(!user) return false;
  if(user.features === 'undefined' || typeof path === 'undefined' || typeof path !== 'string') return false;

	for (var i = 0; i < user.features.length; i++) {
		var feature = user.features[i];
		if(feature.path == path) {
			return true;
			break;
		}
	}
	return false;
});



// WEBPACK FOOTER //
// ./src/common/actions/index.js